import React from 'react';
import { SxStyle } from '../../../../../types';
import RenderModuleFields from '../../../../common/fields/render-fields';
import { Field } from '../../../../../types';
// import { PromosInUse } from '../types';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';

// const INITIAL_PROMOS_IN_USE: PromosInUse = {
//  'promo-0': { mobile: '', tablet: '' },
//  'promo-1': { mobile: '', tablet: '' },
//  'promo-2': { mobile: '', tablet: '' },
//  'promo-3': { mobile: '', tablet: '' },
//  'promo-4': { mobile: '', tablet: '' },
//  'promo-5': { mobile: '', tablet: '' },
//  'promo-6': { mobile: '', tablet: '' },
//  'promo-7': { mobile: '', tablet: '' },
//  'promo-8': { mobile: '', tablet: '' },
//  'promo-9': { mobile: '', tablet: '' },
//  'promo-10': { mobile: '', tablet: '' },
//  'promo-11': { mobile: '', tablet: '' },
//  'promo-12': { mobile: '', tablet: '' },
//  'promo-13': { mobile: '', tablet: '' },
//  'promo-14': { mobile: '', tablet: '' },
//  'promo-15': { mobile: '', tablet: '' },
//  'promo-16': { mobile: '', tablet: '' },
//  'promo-17': { mobile: '', tablet: '' },
// };

const styles: SxStyle = {
  root: {
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingBottom: '24px',
  },
  table: (theme) => ({
    minWidth: 650,
    '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd)': {
      backgroundColor: theme.palette.shades.p10,
    },
  }),
};

type CategoriesPropTypes = {
  category: {
    name: string;
    fields: Field[];
  };
  path: string;
  setChange: (
    key: string,
    value: string | number | boolean | null,
    validation: any,
    isTeamDataValue: boolean
  ) => void;
  setValidation: (key: string, value: string | number | boolean, validation: any) => void;
};

function TeamPromosCategory({ category, path, setChange, setValidation }: CategoriesPropTypes) {
  /* Disabled for now, until we make sceneconfig-preview is working again
  const [promosInUse, setPromosInUse] = useState<PromosInUse>(
    INITIAL_PROMOS_IN_USE
  );
  const promosInUseRef = useRef<PromosInUse>(INITIAL_PROMOS_IN_USE);

  const handleSetPromosInUse = useCallback((promoToUpdate: Partial<PromosInUse>) => {
    const promosInUseRefClone = cloneDeep(promosInUseRef.current);

    const updatedPromosInUse: PromosInUse = {
      ...promosInUseRefClone,
      ...promoToUpdate,
    };

    promosInUseRef.current = updatedPromosInUse;

    // Avoids unnecessary rerendering: setState once useRef has been fully updated
    const lastKeyOfPromosInUse: keyof PromosInUse = 'promo-17';
    if (lastKeyOfPromosInUse in promoToUpdate) {
      setPromosInUse(updatedPromosInUse);
    }
  }, []);
  */

  return (
    <TableContainer component={Paper} elevation={4}>
      <Table sx={styles.table}>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '100px' }}>Kampanj</TableCell>
            <TableCell></TableCell>
            <TableCell>Information</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {category.fields.map((field, index) => (
            <RenderModuleFields
              key={field.id}
              field={field}
              setChange={setChange}
              setValidation={setValidation}
              path={path}
              // setPromosInUse={handleSetPromosInUse}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TeamPromosCategory;
